import { api as axios } from "../../../../shared/axios";
import useSWR from "swr";
import { API_URL } from "../../../../shared/config";

const fetcher = (url) => axios.get(url);

export const createYearGroup = async (data, companyId) => {
    try {
        const request = await axios.post(`${API_URL}/report/esg/${companyId}/`, data);
        return { data: request.data, error: undefined };
    } catch (error) {
        return { data: undefined, error: error };
    }
};

export const createItem = async (data, companyId, year) => {
  try {
      const request = await axios.post(`${API_URL}/report/esg/${companyId}/${year}/items/`, { data });
      return { data: request.data, error: undefined };
  } catch (error) {
      return { data: undefined, error: error };
  }
};

export const useSingleItem = (companyId, year, itemId) => {
  const { data, error } = useSWR(`${API_URL}/report/esg/${companyId}/${year}/items/${itemId}/`, fetcher, );
  return {
    singleItem: data?.data,
    isLoadingSingleItem: !error && !data,
    isErrorSingleItem: error,
  };
};

export const useGetAllItems = (companyId, year) => {
  const { data, error } = useSWR(`${API_URL}/report/esg/${companyId}/${year}/items/`, fetcher, );
  return {
    allItems: data?.data,
    isLoadingAllItems: !error && !data,
    isErrorAllItems: error,
  };
};

export const useGetListCompany = (companyId,key) => {
  const { data, error, mutate } = useSWR(`${API_URL}/report/esg/${companyId}/years/?key=${key}`, fetcher, );
  return {
    listCompany: data?.data,
    isLoadingListCompany: !error && !data,
    isErrorListCompany: error,
    mutateListCompany: mutate,
  };
};

export const useGetListItems = (companyId, selectedYear,key) => {
  const { data, error } = useSWR(`${API_URL}/report/esg/${companyId}/reports/?years=${selectedYear}&key=${key}`, fetcher, );
  return {
    listItems: data?.data,
    isLoadingListItems: !error && !data,
    isErrorListItems: error,
  };
};

export const deleteItem = async (data, companyId, year, itemId) => {
  try {
      const response = await axios.delete(`${API_URL}/report/esg/${companyId}/${year}/items/${itemId}/`, { data });
      return { data: response.data, error: undefined };
  } catch (error) {
      return { data: undefined, error: error };
  }
};

export const updateItem = async (data, companyId, year, itemId) => {
  try {
      const response = await axios.put(`${API_URL}/report/esg/${companyId}/${year}/items/${itemId}/`, data);
      return { data: response.data, error: undefined };
  } catch (error) {
      return { data: undefined, error: error };
  }
};

export const deleteGroup = async (data, companyId, year) => {
  try {
      const response = await axios.delete(`${API_URL}/report/esg/${companyId}/${year}/group/`);
      return { data: response.data, error: undefined };
  } catch (error) {
      return { data: undefined, error: error };
  }
};

export const createOperation = async (data, companyId, year) => {
  try {
      const request = await axios.post(`${API_URL}/report/esg/${companyId}/${year}/operations/`, data);
      return { data: request.data, error: undefined };
  } catch (error) {
      return { data: undefined, error: error };
  }
};

export const updateOperation = async (data, companyId, year) => {
  try {
      const response = await axios.put(`${API_URL}/report/esg/${companyId}/${year}/operations/`, data);
      return { data: response.data, error: undefined };
  } catch (error) {
      return { data: undefined, error: error };
  }
};

export const useGetOperations = (companyId, year) => {
  const { data, error } = useSWR(`${API_URL}/report/esg/${companyId}/${year}/operations/`, fetcher, );
  return {
    operationsData: data?.data,
    isLoadingOperationsData: !error && !data,
    isErrorOperationsData: error,
  };
};
 
export const createShareLink = async (data) => {
  try {
      const request = await axios.post(`${API_URL}/report/access_token/`, data);
      return { data: request.data, error: undefined };
  } catch (error) {
      return { data: undefined, error: error };
  }
};